export const FIGO_REDIRECT_CA = 'FIGO_REDIRECT_CA';
export const FIGO_REDIRECT_ME = 'FIGO_REDIRECT_ME';

export const EVENTS = {
	CLICK: 'embrace_qe_click',
	FORM_FIELD: 'embrace_qe_form_field',
	ERROR: 'embrace_qe_error',
	POPUP: 'embrace_qe_popup',
	TOOLTIP: 'embrace_qe_tooltip',
	FUNNEL: 'funnel_event',
	PURCHASE: 'embrace_qe_purchase'
};

export const CLICK_LOCATIONS = {
	CONTENT_TOP: 'content_top',
	CONTENT_MID: 'content_mid',
	CONTENT_BOTTOM: 'content_bottom',
	CONTENT_POPUP: 'content_popup',
	SCROLL_BAR_RIGHT: 'scroll_bar_right',
	BANNER_HEAD: 'banner_head',
	LOCK_BAR_BOTTOM: 'lock_bar_bottom',
};

export const CLICK_TYPES = {
	CTA: 'cta',
	NAVIGATION: 'navigation',
	BUTTON: 'button',
	EXPANSION: 'expansion'
};

export const FORM_FIELD_TYPES = {
	INPUT: 'input',
	RADIO: 'radio',
	CHECKBOX: 'checkbox',
	SELECT: 'select',
	TOGGLE: 'toggle'
};

export const FORM_NAMES = {
	PET_INFO: 'pet_info',
	ADD_EDIT_PET: 'add_edit_pet',
	CONTACT_INFO: 'contact_info',
	MAILING_ADDRESS: 'mailing_address',
	BILLING_ADDRESS: 'billing_address',
	PHYSICAL_ADDRESS: 'physical_address',
	MORE_QUESTIONS: 'more_questions',
	PAYMENT_INFO: 'payment_info',
	CONFIRM_PURCHASE: 'confirm_purchase',
	OPTIONAL_COVERAGES_POPUP: 'optional_coverages_popup',
	OPTIONAL_COVERAGES_SELECT_POLICY: 'optional_coverages_select_policy',
	VET_VISIT_QUESTION: 'vet_visit_question',
	POLICY_OPTIONS: 'policy_options',
};

export const ERROR_TYPES = {
	INCOMPLETE: 'incomplete_form',
	ACKNOWLEDGE: 'acknowledge_terms',
	API: 'api',
	GENERIC: 'generic',
};

export const POPUP_ACTIONS = {
	CLOSE_CTA: 'close_cta',
	CLOSE: 'close',
	SHOW: 'show'
};

// for sensitive info that can't be sent, use this field so that
// there is a value and it doesn't look like something went wrong
export const REDACTED = '[redacted]';

// click_id format
// ELEMENT-TYPE_LOCATION_DESCRIPTION
// button_content_review-plan

// field_id format
// ELEMENT-TYPE_FORM_DESCRIPTION
// input_contact-info_first-name

// error_id format
// error-TYPE-FORM-DESCRIPTION
// error-api-contact_info

// popup_id format
// popup-PAGE-NAME
// popup-page_2-optional_coverages
